class PDPFAQ extends HTMLElement {
  constructor() {
    super();
    this.questions = this.querySelectorAll('[data-faq-title]');
    this.questionsParents = this.querySelectorAll('[data-faq]');
  }

  connectedCallback() {
    this.questions.forEach(faq => {
      faq.addEventListener('click', this.toggleFAQ.bind(this));
    });
  }

  toggleFAQ(event) {
    const faq = event.currentTarget;
    const parent = faq.parentNode;
    if (parent.classList.contains('faq__question--active')) {
      parent.classList.remove('faq__question--active');
    } else {
      this.questionsParents.forEach(questionParent => {
        questionParent.classList.remove('faq__question--active');
      });
      parent.classList.add('faq__question--active');
    }
    window.scroll({
      behavior: 'smooth', 
      top: parent.offsetTop - 107
    });
  }
}

customElements.define('pdp-faq', PDPFAQ);